/* ============================================================
   LIVVEWELL — SHARED PRODUCT MAIN
   ============================================================ */

(function () {
  'use strict';


  const SELECTOR =
    '[data-lw-product-main]';



  /* ==========================================================
     SHOP ROOT
  ========================================================== */

  function shopRoot() {

    return (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    )
      ? window.Shopify.routes.root
      : '/';

  }



  /* ==========================================================
     MONEY
  ========================================================== */

  function formatMoney(
    cents,
    currency
  ) {

    const amount =
      Number(cents || 0) / 100;


    try {

      return new Intl.NumberFormat(
        document.documentElement.lang ||
        'en',
        {
          style: 'currency',
          currency:
            currency || 'USD'
        }
      ).format(amount);

    } catch (error) {

      return '$' +
        amount.toFixed(2);

    }

  }



  /* ==========================================================
     CONTROLLER
  ========================================================== */

  class LWProductMain {

    constructor(root) {

      if (
        !root ||
        root.dataset.lwProductReady ===
        'true'
      ) {
        return;
      }


      root.dataset.lwProductReady =
        'true';


      this.root =
        root;


      this.readData();

      this.cache();

      this.bind();

      this.syncFromDOM();

      this.update();

      this.setupSticky();

    }



    /* ========================================================
       PRODUCT DATA
    ======================================================== */

    readData() {

      const script =
        this.root.querySelector(
          '[data-lw-product-data]'
        );


      this.data = {
        variants: []
      };


      if (!script) {
        return;
      }


      try {

        this.data =
          JSON.parse(
            script.textContent
          );

      } catch (error) {

        console.error(
          '[Livvewell Product] Invalid product JSON.',
          error
        );

      }

    }



    /* ========================================================
       REFERENCES
    ======================================================== */

    cache() {

      this.form =
        this.root.querySelector(
          '.lw-pmain__form'
        );


      this.variantInput =
        this.root.querySelector(
          '[data-lw-variant-id]'
        );


      this.quantityInput =
        this.root.querySelector(
          '[data-lw-quantity]'
        );


      this.atc =
        this.root.querySelector(
          '[data-lw-atc]'
        );


      this.atcText =
        this.root.querySelector(
          '[data-lw-atc-text]'
        );


      this.atcPrice =
        this.root.querySelector(
          '[data-lw-atc-price]'
        );


      this.price =
        this.root.querySelector(
          '[data-lw-price]'
        );


      this.compare =
        this.root.querySelector(
          '[data-lw-compare-price]'
        );


      this.saleBadge =
        this.root.querySelector(
          '[data-lw-sale-badge]'
        );


      this.savePercent =
        this.root.querySelector(
          '[data-lw-save-percent]'
        );


      this.sku =
        this.root.querySelector(
          '[data-lw-sku]'
        );


      this.error =
        this.root.querySelector(
          '[data-lw-product-error]'
        );


      this.planSelect =
        this.root.querySelector(
          '[data-lw-selling-plan]'
        );


      this.planInput =
        this.root.querySelector(
          '[data-lw-selling-plan-input]'
        );


      this.planWrap =
        this.root.querySelector(
          '[data-lw-plan-wrap]'
        );


      this.subscriptionCard =
        this.root.querySelector(
          '[data-lw-subscription-card]'
        );


      this.subscriptionSaving =
        this.root.querySelector(
          '[data-lw-subscription-saving]'
        );


      this.sticky =
        this.root.querySelector(
          '[data-lw-mobile-sticky]'
        );


      this.stickyButton =
        this.root.querySelector(
          '[data-lw-sticky-atc]'
        );


      this.stickyText =
        this.root.querySelector(
          '[data-lw-sticky-atc-text]'
        );


      this.stickyPrice =
        this.root.querySelector(
          '[data-lw-sticky-price]'
        );


      this.stickyImage =
        this.root.querySelector(
          '[data-lw-sticky-image]'
        );


      this.atcAnchor =
        this.root.querySelector(
          '[data-lw-atc-anchor]'
        );

    }



    /* ========================================================
       INITIAL STATE
    ======================================================== */

    syncFromDOM() {

      this.selectedOptions = [];


      this.root
        .querySelectorAll(
          '[data-lw-option]'
        )
        .forEach(
          function (group) {

            const position =
              Number(
                group.dataset.optionPosition
              ) - 1;


            const selected =
              group.querySelector(
                '[data-lw-option-value].is-selected'
              );


            if (selected) {

              this.selectedOptions[
                position
              ] =
                selected.dataset.optionValue;

            }

          }.bind(this)
        );


      const purchase =
        this.root.querySelector(
          '[data-lw-purchase-option]:checked'
        );


      this.purchaseMode =
        purchase
          ? purchase.value
          : (
              this.data.requiresSellingPlan
                ? 'subscription'
                : 'onetime'
            );


      this.currentVariant =
        this.findVariant() ||
        this.data.variants.find(
          function (variant) {

            return (
              String(variant.id) ===
              String(
                this.variantInput
                  ? this.variantInput.value
                  : ''
              )
            );

          }.bind(this)
        ) ||
        this.data.variants[0] ||
        null;

    }



    /* ========================================================
       BIND
    ======================================================== */

    bind() {

      this.root.addEventListener(
        'click',
        this.handleClick.bind(this)
      );


      this.root.addEventListener(
        'change',
        this.handleChange.bind(this)
      );


      if (this.form) {

        this.form.addEventListener(
          'submit',
          this.handleSubmit.bind(this)
        );

      }


      if (this.stickyButton) {

        this.stickyButton.addEventListener(
          'click',
          function () {

            if (
              !this.form ||
              !this.atc ||
              this.atc.disabled
            ) {
              return;
            }


            this.form.requestSubmit(
              this.atc
            );

          }.bind(this)
        );

      }

    }



    /* ========================================================
       CLICK
    ======================================================== */

    handleClick(event) {

      const option =
        event.target.closest(
          '[data-lw-option-value]'
        );


      if (
        option &&
        !option.disabled
      ) {

        event.preventDefault();

        this.selectOption(
          option
        );

        return;

      }



      const thumb =
        event.target.closest(
          '[data-lw-media-thumb]'
        );


      if (thumb) {

        event.preventDefault();

        this.showMedia(
          thumb.dataset.mediaId
        );

        return;

      }



      if (
        event.target.closest(
          '[data-lw-media-prev]'
        )
      ) {

        event.preventDefault();

        this.changeMedia(-1);

        return;

      }



      if (
        event.target.closest(
          '[data-lw-media-next]'
        )
      ) {

        event.preventDefault();

        this.changeMedia(1);

        return;

      }



      if (
        event.target.closest(
          '[data-lw-quantity-minus]'
        )
      ) {

        event.preventDefault();

        this.changeQuantity(-1);

        return;

      }



      if (
        event.target.closest(
          '[data-lw-quantity-plus]'
        )
      ) {

        event.preventDefault();

        this.changeQuantity(1);

      }

    }



    /* ========================================================
       CHANGE
    ======================================================== */

    handleChange(event) {

      if (
        event.target.matches(
          '[data-lw-purchase-option]'
        )
      ) {

        this.purchaseMode =
          event.target.value;


        this.root
          .querySelectorAll(
            '.lw-pmain__purchase-card'
          )
          .forEach(
            function (card) {

              const radio =
                card.querySelector(
                  '[data-lw-purchase-option]'
                );


              card.classList.toggle(
                'is-active',
                !!radio &&
                radio.checked
              );

            }
          );


        this.update();

        return;

      }



      if (
        event.target.matches(
          '[data-lw-selling-plan]'
        )
      ) {

        this.update();

        return;

      }



      if (
        event.target.matches(
          '[data-lw-quantity]'
        )
      ) {

        this.sanitizeQuantity();

      }

    }



    /* ========================================================
       SELECT OPTION
    ======================================================== */

    selectOption(button) {

      const group =
        button.closest(
          '[data-lw-option]'
        );


      if (!group) {
        return;
      }


      const position =
        Number(
          group.dataset.optionPosition
        ) - 1;


      group
        .querySelectorAll(
          '[data-lw-option-value]'
        )
        .forEach(
          function (item) {

            const selected =
              item === button;


            item.classList.toggle(
              'is-selected',
              selected
            );


            item.setAttribute(
              'aria-pressed',
              String(selected)
            );

          }
        );


      this.selectedOptions[
        position
      ] =
        button.dataset.optionValue;


      const selectedLabel =
        group.querySelector(
          '[data-lw-selected-option]'
        );


      if (selectedLabel) {

        selectedLabel.textContent =
          button.dataset.optionValue;

      }


      this.currentVariant =
        this.findVariant();


      this.update();

    }



    /* ========================================================
       FIND VARIANT
    ======================================================== */

    findVariant() {

      return this.data.variants.find(
        function (variant) {

          if (
            !Array.isArray(
              variant.options
            )
          ) {
            return false;
          }


          return variant.options.every(
            function (
              value,
              index
            ) {

              return (
                String(value) ===
                String(
                  this.selectedOptions[
                    index
                  ]
                )
              );

            }.bind(this)
          );

        }.bind(this)
      ) || null;

    }



    /* ========================================================
       UPDATE EVERYTHING
    ======================================================== */

    update() {

      const variant =
        this.currentVariant;


      if (!variant) {

        this.setUnavailable();

        return;

      }


      if (this.variantInput) {

        this.variantInput.value =
          variant.id;

      }


      this.updateOptionAvailability();

      this.updateSellingPlans();

      this.updatePrice();

      this.updateQuantityRules();

      this.updateAvailability();

      this.updateSKU();

      this.updateMediaFromVariant();

      this.updateURL();

    }



    /* ========================================================
       OPTION AVAILABILITY
    ======================================================== */

    updateOptionAvailability() {

      this.root
        .querySelectorAll(
          '[data-lw-option]'
        )
        .forEach(
          function (group) {

            const position =
              Number(
                group.dataset.optionPosition
              ) - 1;


            group
              .querySelectorAll(
                '[data-lw-option-value]'
              )
              .forEach(
                function (button) {

                  const candidate =
                    button.dataset.optionValue;


                  const available =
                    this.data.variants.some(
                      function (variant) {

                        if (
                          !variant.available
                        ) {
                          return false;
                        }


                        return variant.options.every(
                          function (
                            value,
                            index
                          ) {

                            if (
                              index ===
                              position
                            ) {

                              return (
                                String(value) ===
                                String(candidate)
                              );

                            }


                            const selected =
                              this.selectedOptions[
                                index
                              ];


                            return (
                              !selected ||
                              String(value) ===
                              String(selected)
                            );

                          }.bind(this)
                        );

                      }.bind(this)
                    );


                  button.disabled =
                    !available;

                }.bind(this)
              );

          }.bind(this)
        );

    }



    /* ========================================================
       SELLING PLANS
    ======================================================== */

    updateSellingPlans() {

      const variant =
        this.currentVariant;


      if (!variant) {
        return;
      }


      const allocations =
        variant.sellingPlanAllocations ||
        [];


      if (
        !this.planSelect
      ) {
        return;
      }


      const validIds =
        new Set(
          allocations.map(
            function (allocation) {

              return String(
                allocation.id
              );

            }
          )
        );


      let firstAvailable =
        null;


      Array.from(
        this.planSelect.options
      ).forEach(
        function (option) {

          const available =
            validIds.has(
              String(option.value)
            );


          option.disabled =
            !available;


          option.hidden =
            !available;


          if (
            available &&
            firstAvailable === null
          ) {

            firstAvailable =
              option.value;

          }

        }
      );


      if (
        !validIds.has(
          String(
            this.planSelect.value
          )
        )
      ) {

        this.planSelect.value =
          firstAvailable || '';

      }


      const subscriptionRadio =
        this.root.querySelector(
          '[data-lw-purchase-option][value="subscription"]'
        );


      if (subscriptionRadio) {

        subscriptionRadio.disabled =
          allocations.length === 0;

      }



      /*
        Product requires a selling plan.
      */

      if (
        this.data.requiresSellingPlan
      ) {

        this.purchaseMode =
          'subscription';


        if (subscriptionRadio) {

          subscriptionRadio.checked =
            true;

        }

      }



      if (
        this.purchaseMode ===
        'subscription' &&
        allocations.length === 0 &&
        !this.data.requiresSellingPlan
      ) {

        this.purchaseMode =
          'onetime';


        const oneTimeRadio =
          this.root.querySelector(
            '[data-lw-purchase-option][value="onetime"]'
          );


        if (oneTimeRadio) {

          oneTimeRadio.checked =
            true;

        }

      }


      this.root
        .querySelectorAll(
          '.lw-pmain__purchase-card'
        )
        .forEach(
          function (card) {

            const radio =
              card.querySelector(
                '[data-lw-purchase-option]'
              );


            card.classList.toggle(
              'is-active',
              !!radio &&
              radio.checked
            );

          }
        );


      if (this.planWrap) {

        this.planWrap.hidden =
          this.purchaseMode !==
          'subscription';

      }


      if (this.planInput) {

        if (
          this.purchaseMode ===
          'subscription'
        ) {

          this.planInput.disabled =
            false;


          this.planInput.value =
            this.planSelect.value ||
            firstAvailable ||
            '';

        } else {

          this.planInput.disabled =
            true;


          this.planInput.value =
            '';

        }

      }


      this.updateSubscriptionSaving();

    }



    /* ========================================================
       ALLOCATION
    ======================================================== */

    getSelectedAllocation() {

      if (
        !this.currentVariant ||
        this.purchaseMode !==
        'subscription' ||
        !this.planSelect
      ) {
        return null;
      }


      const id =
        String(
          this.planSelect.value
        );


      return (
        this.currentVariant
          .sellingPlanAllocations ||
        []
      ).find(
        function (allocation) {

          return (
            String(
              allocation.id
            ) === id
          );

        }
      ) || null;

    }



    /* ========================================================
       SUBSCRIPTION SAVINGS
    ======================================================== */

    updateSubscriptionSaving() {

      if (
        !this.subscriptionSaving ||
        !this.currentVariant
      ) {
        return;
      }


      const allocations =
        this.currentVariant
          .sellingPlanAllocations ||
        [];


      if (!allocations.length) {

        this.subscriptionSaving
          .textContent =
            'Unavailable for this option';

        return;

      }


      const allocation =
        allocations[0];


      const base =
        Number(
          allocation.compareAt ||
          this.currentVariant.price
        );


      const price =
        Number(
          allocation.price
        );


      if (
        base > price &&
        base > 0
      ) {

        const saving =
          Math.round(
            (
              (base - price) /
              base
            ) * 100
          );


        this.subscriptionSaving
          .textContent =
            'Save ' +
            saving +
            '%';

      } else {

        this.subscriptionSaving
          .textContent =
            'Subscribe & save';

      }

    }



    /* ========================================================
       PRICE
    ======================================================== */

    updatePrice() {

      if (!this.currentVariant) {
        return;
      }


      let price =
        Number(
          this.currentVariant.price
        );


      let compare =
        Number(
          this.currentVariant.compareAt ||
          0
        );


      const allocation =
        this.getSelectedAllocation();


      if (allocation) {

        price =
          Number(
            allocation.price
          );


        compare =
          Number(
            allocation.compareAt ||
            compare
          );

      }


      const onSale =
        compare > price;


      if (this.price) {

        this.price.textContent =
          formatMoney(
            price,
            this.data.currency
          );

      }


      if (this.atcPrice) {

        this.atcPrice.textContent =
          formatMoney(
            price,
            this.data.currency
          );

      }


      if (this.stickyPrice) {

        this.stickyPrice.textContent =
          formatMoney(
            price,
            this.data.currency
          );

      }


      if (this.compare) {

        this.compare.hidden =
          !onSale;


        this.compare.textContent =
          onSale
            ? formatMoney(
                compare,
                this.data.currency
              )
            : '';

      }


      if (this.saleBadge) {

        this.saleBadge.hidden =
          !onSale;

      }


      if (
        onSale &&
        this.savePercent
      ) {

        const saving =
          Math.round(
            (
              (compare - price) /
              compare
            ) * 100
          );


        this.savePercent.textContent =
          saving + '%';

      }

    }



    /* ========================================================
       AVAILABILITY
    ======================================================== */

    updateAvailability() {

      const available =
        !!(
          this.currentVariant &&
          this.currentVariant.available
        );


      if (this.atc) {

        this.atc.disabled =
          !available;


        const addLabel =
          this.atc.dataset.addLabel ||
          'Add to cart';


        const soldLabel =
          this.atc.dataset.soldLabel ||
          'Sold out';


        if (this.atcText) {

          this.atcText.textContent =
            available
              ? addLabel
              : soldLabel;

        }


        if (this.stickyButton) {

          this.stickyButton.disabled =
            !available;

        }


        if (this.stickyText) {

          this.stickyText.textContent =
            available
              ? addLabel
              : soldLabel;

        }

      }

    }



    /* ========================================================
       NO MATCH
    ======================================================== */

    setUnavailable() {

      if (this.atc) {

        this.atc.disabled =
          true;

      }


      if (this.atcText) {

        this.atcText.textContent =
          'Unavailable';

      }


      if (this.stickyButton) {

        this.stickyButton.disabled =
          true;

      }


      if (this.stickyText) {

        this.stickyText.textContent =
          'Unavailable';

      }

    }



    /* ========================================================
       SKU
    ======================================================== */

    updateSKU() {

      if (!this.sku) {
        return;
      }


      this.sku.textContent =
        this.currentVariant &&
        this.currentVariant.sku
          ? 'SKU ' +
            this.currentVariant.sku
          : '';

    }



    /* ========================================================
       QUANTITY RULES
    ======================================================== */

    updateQuantityRules() {

      if (
        !this.quantityInput ||
        !this.currentVariant
      ) {
        return;
      }


      const rules =
        this.currentVariant
          .quantityRule || {};


      const min =
        Number(
          rules.min || 1
        );


      const increment =
        Number(
          rules.increment || 1
        );


      this.quantityInput.min =
        min;


      this.quantityInput.step =
        increment;


      if (rules.max) {

        this.quantityInput.max =
          rules.max;

      } else {

        this.quantityInput
          .removeAttribute(
            'max'
          );

      }


      if (
        Number(
          this.quantityInput.value
        ) < min
      ) {

        this.quantityInput.value =
          min;

      }

    }



    /* ========================================================
       QUANTITY BUTTON
    ======================================================== */

    changeQuantity(direction) {

      if (!this.quantityInput) {
        return;
      }


      const current =
        Number(
          this.quantityInput.value ||
          1
        );


      const min =
        Number(
          this.quantityInput.min ||
          1
        );


      const max =
        this.quantityInput.max
          ? Number(
              this.quantityInput.max
            )
          : Infinity;


      const step =
        Number(
          this.quantityInput.step ||
          1
        );


      let next =
        current +
        (
          direction * step
        );


      next =
        Math.max(
          min,
          Math.min(
            max,
            next
          )
        );


      this.quantityInput.value =
        next;

    }



    /* ========================================================
       SANITIZE QUANTITY
    ======================================================== */

    sanitizeQuantity() {

      if (!this.quantityInput) {
        return;
      }


      const min =
        Number(
          this.quantityInput.min ||
          1
        );


      const max =
        this.quantityInput.max
          ? Number(
              this.quantityInput.max
            )
          : Infinity;


      let value =
        Number(
          this.quantityInput.value
        );


      if (
        !Number.isFinite(value)
      ) {

        value = min;

      }


      value =
        Math.max(
          min,
          Math.min(
            max,
            value
          )
        );


      this.quantityInput.value =
        value;

    }



    /* ========================================================
       VARIANT MEDIA
    ======================================================== */

    updateMediaFromVariant() {

      if (
        !this.currentVariant ||
        !this.currentVariant
          .featuredMediaId
      ) {
        return;
      }


      this.showMedia(
        this.currentVariant
          .featuredMediaId
      );


      if (
        this.stickyImage &&
        this.currentVariant
          .featuredImage
      ) {

        this.stickyImage.src =
          this.currentVariant
            .featuredImage;

      }

    }



    /* ========================================================
       SHOW MEDIA
    ======================================================== */

    showMedia(mediaId) {

      const id =
        String(mediaId);


      const media =
        this.root.querySelector(
          '[data-lw-product-media][data-media-id="' +
          CSS.escape(id) +
          '"]'
        );


      if (!media) {
        return;
      }


      this.root
        .querySelectorAll(
          '[data-lw-product-media]'
        )
        .forEach(
          function (item) {

            const active =
              item === media;


            item.hidden =
              !active;


            item.classList.toggle(
              'is-active',
              active
            );

          }
        );


      this.root
        .querySelectorAll(
          '[data-lw-media-thumb]'
        )
        .forEach(
          function (thumb) {

            const active =
              String(
                thumb.dataset.mediaId
              ) === id;


            thumb.classList.toggle(
              'is-active',
              active
            );


            thumb.setAttribute(
              'aria-pressed',
              String(active)
            );

          }
        );


      this.updateMediaCounter();

    }



    /* ========================================================
       MEDIA NAVIGATION
    ======================================================== */

    changeMedia(direction) {

      const media =
        Array.from(
          this.root.querySelectorAll(
            '[data-lw-product-media]'
          )
        );


      if (!media.length) {
        return;
      }


      let index =
        media.findIndex(
          function (item) {

            return (
              !item.hidden
            );

          }
        );


      if (index < 0) {
        index = 0;
      }


      index =
        (
          index +
          direction +
          media.length
        ) %
        media.length;


      this.showMedia(
        media[index]
          .dataset.mediaId
      );

    }



    /* ========================================================
       COUNTER
    ======================================================== */

    updateMediaCounter() {

      const media =
        Array.from(
          this.root.querySelectorAll(
            '[data-lw-product-media]'
          )
        );


      const active =
        media.findIndex(
          function (item) {

            return !item.hidden;

          }
        );


      const counter =
        this.root.querySelector(
          '[data-lw-media-counter]'
        );


      if (
        counter &&
        active >= 0
      ) {

        counter.textContent =
          (
            active + 1
          ) +
          ' / ' +
          media.length;

      }

    }



    /* ========================================================
       URL
    ======================================================== */

    updateURL() {

      if (
        !this.currentVariant ||
        !window.history ||
        !window.history.replaceState
      ) {
        return;
      }


      const url =
        new URL(
          window.location.href
        );


      url.searchParams.set(
        'variant',
        this.currentVariant.id
      );


      window.history.replaceState(
        {},
        '',
        url.toString()
      );

    }



    /* ========================================================
       ERROR
    ======================================================== */

    showError(message) {

      if (!this.error) {
        return;
      }


      this.error.textContent =
        message;


      this.error.hidden =
        false;

    }



    /* ========================================================
       CLEAR ERROR
    ======================================================== */

    clearError() {

      if (!this.error) {
        return;
      }


      this.error.textContent =
        '';


      this.error.hidden =
        true;

    }



    /* ========================================================
       SUBMIT
    ======================================================== */

    async handleSubmit(event) {

      event.preventDefault();

      event.stopPropagation();


      this.clearError();


      if (
        !this.currentVariant ||
        !this.currentVariant.available
      ) {

        this.showError(
          'This option is currently unavailable.'
        );

        return;

      }



      const quantity =
        Math.max(
          1,
          Number(
            this.quantityInput
              ? this.quantityInput.value
              : 1
          ) || 1
        );


      const item = {

        id:
          Number(
            this.currentVariant.id
          ),

        quantity:
          quantity

      };


      if (
        this.purchaseMode ===
        'subscription'
      ) {

        const allocation =
          this.getSelectedAllocation();


        if (!allocation) {

          this.showError(
            'Please choose a delivery frequency.'
          );

          return;

        }


        item.selling_plan =
          Number(
            allocation.id
          );

      }


      this.setLoading(
        true
      );


      try {

        const response =
          await fetch(
            shopRoot() +
            'cart/add.js',
            {
              method: 'POST',

              headers: {

                'Content-Type':
                  'application/json',

                Accept:
                  'application/json',

                'X-Requested-With':
                  'XMLHttpRequest'

              },

              body:
                JSON.stringify({
                  items: [
                    item
                  ]
                })

            }
          );


        let result = {};


        try {

          result =
            await response.json();

        } catch (error) {}


        if (!response.ok) {

          throw new Error(
            result.description ||
            result.message ||
            'Unable to add this product to your cart.'
          );

        }



        /*
          The global Livvewell cart drawer observes
          /cart/add.js and will refresh/open itself.
        */

        document.dispatchEvent(
          new CustomEvent(
            'lw:product-main:added',
            {
              detail: {
                productId:
                  this.data.productId,

                variantId:
                  this.currentVariant.id,

                quantity:
                  quantity,

                response:
                  result
              }
            }
          )
        );


      } catch (error) {

        console.error(
          '[Livvewell Product] Add to cart failed:',
          error
        );


        this.showError(
          error.message ||
          'Unable to add this product to your cart.'
        );


      } finally {

        this.setLoading(
          false
        );

      }

    }



    /* ========================================================
       LOADING
    ======================================================== */

    setLoading(state) {

      if (!this.atc) {
        return;
      }


      this.atc.classList.toggle(
        'is-loading',
        state
      );


      this.atc.disabled =
        state ||
        !(
          this.currentVariant &&
          this.currentVariant.available
        );


      if (this.stickyButton) {

        this.stickyButton.disabled =
          state ||
          !(
            this.currentVariant &&
            this.currentVariant.available
          );

      }

    }



    /* ========================================================
       MOBILE STICKY
    ======================================================== */

    setupSticky() {

      if (
        !this.sticky ||
        !this.atcAnchor ||
        !('IntersectionObserver' in window)
      ) {
        return;
      }


      const observer =
        new IntersectionObserver(
          function (entries) {

            const entry =
              entries[0];


            /*
              Only show once the main ATC has
              actually scrolled ABOVE the viewport.

              If it is still below the viewport during
              the gallery portion, don't show it yet.
            */

            const shouldShow =
              !entry.isIntersecting &&
              entry.boundingClientRect.top <
              0;


            this.sticky.classList.toggle(
              'is-visible',
              shouldShow
            );


            this.sticky.setAttribute(
              'aria-hidden',
              String(
                !shouldShow
              )
            );

          }.bind(this),
          {
            threshold: 0
          }
        );


      observer.observe(
        this.atcAnchor
      );

    }

  }



  /* ==========================================================
     INITIALIZE
  ========================================================== */

  function init(scope) {

    const context =
      scope || document;


    if (
      context.matches &&
      context.matches(
        SELECTOR
      )
    ) {

      new LWProductMain(
        context
      );

    }


    context
      .querySelectorAll(
        SELECTOR
      )
      .forEach(
        function (root) {

          new LWProductMain(
            root
          );

        }
      );

  }



  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      function () {

        init(document);

      }
    );

  } else {

    init(document);

  }



  document.addEventListener(
    'shopify:section:load',
    function (event) {

      init(
        event.target
      );

    }
  );

})();